import React from 'react';
import { Badge } from '@chakra-ui/react';

const base = {
    fontSize: '0.65rem',
    fontWeight: 800,
    textTransform: 'uppercase',
    px: 2,
    py: 1,
    borderRadius: 'md',
    letterSpacing: '0.5px',
};

export const StatusBadge = ({ status }) => {
    const map = {
        'Em Andamento': { bg: 'rgba(49,130,206,0.15)', color: '#63B3ED' },
        'Concluida': { bg: 'rgba(2,189,109,0.15)', color: '#02EA75' },
        'Parada': { bg: 'rgba(229,62,62,0.15)', color: '#FC8181' },
    };
    const style = map[status] || { bg: 'surfaceRaised', color: 'textSecondary' };
    return (
        <Badge {...base} bg={style.bg} color={style.color}>
            {status || '-'}
        </Badge>
    );
};

export const PrioridadeBadge = ({ prioridade }) => {
    if (!prioridade) return <Badge {...base} bg="surfaceRaised" color="textSecondary">-</Badge>;
    const map = {
        URGENTE: { bg: 'rgba(229,62,62,0.15)', color: '#FC8181' },
        ALTA: { bg: 'rgba(236,201,75,0.15)', color: '#F6E05E' },
        MÉDIA: { bg: 'rgba(49,130,206,0.15)', color: '#63B3ED' },
        BAIXA: { bg: 'rgba(2,189,109,0.15)', color: '#02EA75' },
    };
    const style = map[prioridade] || { bg: 'surfaceRaised', color: 'textSecondary' };
    return (
        <Badge {...base} bg={style.bg} color={style.color}>
            {prioridade}
        </Badge>
    );
};

export const SituacaoBadge = ({ situacao }) => {
    if (!situacao || situacao === 'SEM DADOS')
        return <Badge {...base} bg="surfaceRaised" color="textSecondary">-</Badge>;
    const u = situacao.toUpperCase();
    let style = { bg: 'surfaceRaised', color: 'textSecondary' };
    if (u.includes('CONCLUIDO')) style = { bg: 'rgba(2,189,109,0.15)', color: '#02EA75' };
    else if (u.includes('TESTE')) style = { bg: 'rgba(180,167,214,0.15)', color: '#D6BCFA' };
    else if (u.includes('SENDO') || u.includes('PRONTO'))
        style = { bg: 'rgba(49,130,206,0.15)', color: '#63B3ED' };
    else if (u.includes('COLETANDO') || u.includes('ESPERANDO'))
        style = { bg: 'rgba(236,201,75,0.15)', color: '#F6E05E' };
    else if (u.includes('PARADO') || u.includes('NÃO TEM'))
        style = { bg: 'rgba(229,62,62,0.15)', color: '#FC8181' };

    const label = situacao.length > 22 ? situacao.slice(0, 22) + '…' : situacao;
    return (
        <Badge {...base} bg={style.bg} color={style.color} title={situacao}>
            {label}
        </Badge>
    );
};
